export default __webpack_public_path__ + "static/media/257-sardinia.a043a06d.svg";